import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTypeRestoringFailedAction = {
	type: 'DOCUMENT_TYPE_RESTORING_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTypeRestoringFailedAction => ({
	type: 'DOCUMENT_TYPE_RESTORING_FAILED',
	payload,
});
